export const messages = {
  en: {
    printSmallAccountReceipt: {
      title: 'Prepaid Receipt',
      receiptNum: 'Receipt No.',
      feeTime: 'Time',
      acctName: 'Account Name:',
      acctTypeName: 'Account Type:',
      ownerName: 'Owner:',
      receivedAmount: 'Prepaid Amount:',
      primeRateName: 'Prepaid Method:',
      amount: 'Current Balance:',
      remark: 'Remark:',
      totalAmount: 'Total',
      issuer: 'Issuer',
      print: 'Print',
      cloudPrint: 'Cloud Print',
      cancel: 'Cancel',
      printer: 'Printer',
      quantity: 'Quantity',
      printSuccess: 'Print submitted successfully',
      requiredPrinter: 'Required, please select a printer',
      requiredQuantity: 'Required, please enter quantity'
    }
  },
  zh: {
    printSmallAccountReceipt: {
      title: '预存收据单',
      receiptNum: '单号',
      feeTime: '时间',
      acctName: '账户名称：',
      acctTypeName: '账户类型：',
      ownerName: '业主：',
      receivedAmount: '预存金额：',
      primeRateName: '预存方式：',
      amount: '当前余额：',
      remark: '备注：',
      totalAmount: '总计',
      issuer: '开票人',
      print: '打印',
      cloudPrint: '云打印',
      cancel: '取消',
      printer: '打印机',
      quantity: '数量',
      printSuccess: '打印提交成功',
requiredPrinter: '必填，请选择打印机',
      requiredQuantity: '必填，请填写数量'
    }
  },
  'zh-TW': {
    printSmallAccountReceipt: {
      title: '預存收據單',
      receiptNum: '單號',
      feeTime: '時間',
      acctName: '賬戶名稱：',
      acctTypeName: '賬戶類型：',
      ownerName: '業主：',
      receivedAmount: '預存金額：',
      primeRateName: '預存方式：',
      amount: '當前餘額：',
      remark: '備註：',
      totalAmount: '總計',
      issuer: '開票人',
      print: '列印',
      cloudPrint: '雲列印',
      cancel: '取消',
      printer: '印表機',
      quantity: '數量',
      printSuccess: '列印提交成功',
      requiredPrinter: '必填，請選擇印表機',
      requiredQuantity: '必填，請填寫數量'
    }
  }
}